import dayjs, { Dayjs } from 'dayjs';

export function isValidYearMonth(yearMonthString: string | null) {
  if (!yearMonthString) {
    return false;
  }
  const yearMonthDate = dayjs(yearMonthString, 'YYYY-MM');
  return yearMonthDate.isValid() && yearMonthDate.year() >= 2020 && yearMonthDate.isBefore(dayjs());
}

export function isPreviousYear(currentYearMonth: string | null, newYearMonth: string) {
  const currentDate = dayjs(currentYearMonth, 'YYYY-MM');
  const newDate = dayjs(newYearMonth, 'YYYY-MM');
  if (currentDate.year() - 1 === newDate.year()) {
    return true;
  }
  return false;
}

export function getDiffDaysFromNow(futureTimeUtc: Dayjs, currentTimeUtc?: Dayjs) {
  let futureTime = dayjs.utc(futureTimeUtc);
  let nowTime = dayjs.utc(currentTimeUtc || dayjs.utc());
  if (futureTime.isBefore(nowTime)) {
    return -1;
  }
  return futureTime.diff(nowTime, 'days');
}

// Guessed once: dayjs.tz.guess() is slow and the dashboard displays a date per row
let userTimezone: string | undefined;
function guessUserTimezone() {
  return (userTimezone ??= dayjs.tz.guess());
}

export function displayTime(timeUtc: any) {
  return dayjs.utc(timeUtc).tz(guessUserTimezone()).format('DD/MM/YYYY hh:mma');
}

export function displayTimeWithBrisbaneTz(timeUtc: any) {
  return dayjs.utc(timeUtc).tz('Australia/Brisbane').format('DD/MM/YYYY hh:mma');
}

// For dates without a time (e.g. last payrun posted): nothing to convert to a timezone
export function displayLocalDate(date: string) {
  return dayjs(date).format('DD/MM/YYYY');
}

export function displayDate(dateUtc: any) {
  return dayjs.utc(dateUtc).tz(guessUserTimezone()).format('DD/MM/YYYY');
}

export function displayYearMonth(yearMonth: any) {
  return dayjs(yearMonth, 'YYYY-MM').format('MMMM YYYY');
}

export function isAfterEndOfMonth(yearMonthString: string | null, dateUtc: any) {
  if (dateUtc == null || yearMonthString == null) {
    return false;
  }
  const endOfCurrentMonth = dayjs(yearMonthString, 'YYYY-MM').endOf('month');
  return dayjs(dateUtc).isAfter(endOfCurrentMonth);
}

export function getCurrentYearMonth() {
  return dayjs(new Date()).format('YYYY-MM');
}

/** Move a YYYY-MM value by a number of months, e.g. shiftYearMonth('2026-01', -1) === '2025-12'. */
export function shiftYearMonth(yearMonth: string, months: number) {
  return dayjs(yearMonth, 'YYYY-MM').add(months, 'month').format('YYYY-MM');
}
